module.exports = __webpack_public_path__ + "img/my-account-ico.d49c784e.svg";